import * as React from 'react';
import { Layout, LayoutProps } from 'react-admin';
import AppBar from './AppBar';
import Menu from './Menu';
import MarketingAdminRouteGuard from './MarketingAdminRouteGuard';

export default (props: LayoutProps) => (
    <MarketingAdminRouteGuard>
        <Layout {...props} appBar={AppBar} menu={Menu} />
    </MarketingAdminRouteGuard>
);
